//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import WebIM from '~/utils/WebIm'
import liveDiscussion from '~/components/liveroom/liveDiscussion.vue' // 直播讨论
export default {
  components: {
    'live-discussion': liveDiscussion // 面包屑导航
  },
  props: {
    liveDetail: { // 直播详情数据
      type: Object,
      default: () => {}
    },
    liveChatList: { // 历史消息
      type: Object,
      default: () => {}
    },
    liveConfig: { // 切流数据
      type: Object,
      default: () => {}
    },
    liveAudience: { // 在线观众
      type: [Number, String],
      default: () => {}
    }
  },
  data () {
    return {
      state: this.liveDetail.livestatus != 3 ? 2 : 1,
      // tabs: [{ text: this.$v('直播简介'), state: 1 }, { text: this.$v('互动区'), state: 2 }], // tab栏
      msgList: { // 消息列表
        chatroom: {}
      },
      userIds: [], // userId合集
      userInfoColl: [], // 用户信息合集
      nickName: {}, // 当前用户信息
      onlineAudience: this.liveAudience, // 在线观众
      msg_text: '', // IM消息
      Forbidden: false // 禁言状态
    }
  },
  computed: {
    ...mapState({
      contentcookie: 'contentcookie'
    }),
    tabs () {
      if (this.liveDetail.livestatus != 3) {
        return [{ text: this.$v('直播简介'), state: 1 }, { text: this.$v('互动区'), state: 2 }]
      } else {
        return [{ text: this.$v('直播简介'), state: 1 }]
      }
    },
    isZh () {
      const code = this.$store.state.LanguageCode
      if (code == 'zh-cn' || code == 'zh-tw' || code == 'zh-hk' || code == 'zh') {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    // 监听输入的交易商名称的变化
    contentcookie (newV) {
      WebIM.conn.close() // 断开连接
      console.log('%c [opened] 连接已断开', 'color: green')
      this.getCookUser()
    }
  },
  created () {
  },
  mounted () {
    this.getCookUser()
    if (!this.liveChatList.total) return
    this.msgList.chatroom[this.liveDetail.chatroomid] = []
    this.liveChatList.total && this.liveChatList.items.forEach((item) => { // 历史消息添加
      this.$store.commit('updateMsgList', {
        chatType: 'chatroom',
        chatId: this.liveDetail.chatroomid,
        msg: item.content,
        bySelf: true,
        time: item.wiki_timestamp,
        mid: this.liveDetail.chatroomid,
        status: 'sending',
        nick: item.nick
      })
    })
  },
  methods: {
    async getCookUser () {
      if (this.contentcookie) {
        const res = await this.$api.liveroom.liveToken({
          userId: this.$store.state.user.userId
        })
        if (!res) return
        this.IMlogin(this.$store.state.user.userId, res.access_token)
      } else {
        const wiki = this.$Cookie.get('wiki-bfp')
        if (!wiki) return
        const res = await this.$api.liveroom.liveToken({
          userId: wiki
        })
        this.IMlogin(wiki, res.access_token)
      }
    },
    mText (txt) {
      this.msg_text = txt
    },
    IMlogin (id, token) { // im 登录
      // console.log('id, token: ', id, token)
      const options = {
        user: id,
        accessToken: token,
        appKey: '1126200310098622#wikifx-im'
      }
      WebIM.logger.disableAll() // 关闭SDK log
      WebIM.conn.open(options) // IM登录
      /** ******************************* 注册IM 回调 *************************/
      const that = this
      WebIM.conn.listen({
        onOpened (message) {
          // 连接成功回调
          console.log('%c [opened] 连接已成功建立', 'color: green')
          if (that.liveDetail.livestatus == 1) {
            that.$message({
              message: that.$v('初始化成功'),
              type: 'success'
            })
          }

          // 加入聊天室
          that.getIMlist()
        },
        onClosed (message) {
          console.log('退出登陆')
        }, // 连接关闭回调
        async onTextMessage  (message) {
          console.log('onTextMessage: ', message)
          // 判断是否有扩展字段，会议ID是否为空，如果有会议ID 就加入会议
          const stat = that.userIds.indexOf(message.from)
          if (stat == -1) {
            that.userIds.push(message.from)
            const aa = await that.$api.liveroom.liveusers({
              userIds: [message.from],
              languageCode: that.$store.state.LanguageCode
            })
            that.userInfoColl.push(aa[0])
            if (that.userInfoColl.length > 0) {
              that.nickName = that.userInfoColl.find((i) => {
                return i.userId == message.from
              })
            }
          } else if (that.userInfoColl.length > 0) {
            that.nickName = that.userInfoColl.find((i) => {
              return i.userId == message.from
            })
          }
          if (that.nickName && that.nickName.nickName) {
            that.$store.commit('updateMsgList', {
              chatType: 'chatroom',
              chatId: message.to,
              msg: message.data,
              bySelf: false,
              from: message.from,
              mid: message.id,
              time: message.time,
              nick: that.nickName.nickName
            })
          }
          that.$nextTick(() => {
            that.$refs.livediscussion.html_scroll()
          })
        }, // 收到文本消息
        onEmojiMessage (message) {
          console.log('onEmojiMessage: ', message)
        }, // 收到表情消息
        onPictureMessage (message) {
          console.log('onPicMessage: ', message)
        }, // 收到图片消息
        onCmdMessage (message) {
          console.log('onCmdMessage: ', message)
          if (message && message.ext.livestatus == '3' && message.to == that.liveDetail.chatroomid) { // 结束直播
            that.$emit('endliveBroadcast', true)
            that.$store.commit('setanchor', false)
            that.$cookies.remove(`anchor${that.liveDetail.livecode}`)
          } else if (message && message.ext.event == '11' && message.to == that.liveDetail.chatroomid) {
            const langabj = message.ext
            for (const key in langabj) {
              // console.log(key, that.$store.state.lang_speak_lang, 999);
              if (key == that.$store.state.lang_speak_lang) {
                console.log(langabj[key], 8887)
                that.$store.commit('set_lang_speak', langabj[key])
              }
            }
          } else if (message && message.ext.event == '12' && message.ext.isswitch == 'true' && message.to == that.liveDetail.chatroomid) { // 切流
            that.$emit('TangentialFlow', true) // 切流
          } else if (message && message.ext.event == '12' && message.ext.isswitch == 'false' && message.to == that.liveDetail.chatroomid) {
            that.$emit('TangentialFlow', false) // 切流恢复
          } else if (message && message.ext.event == '13' && message.ext.livestatus == '1' && message.to == that.liveDetail.chatroomid) { // 提前开播
            that.$store.commit('UPDATE_PLAY_STATE', 'playing')
            if (that.liveDetail.livestatus == 2)location.reload()
            // location.reload()
          } else if (message.ext.event == '14') { // 删除信息
            const arr = that.$store.state.msgList
            arr.chatroom[that.chatroomid].forEach((res, index) => {
              if (res.mid == message.ext.msgId) {
                arr.chatroom[that.chatroomid].splice(index, 1)
              }
            })
            that.$store.commit('set_msg', { arr, chatId: that.chatroomid })
          } else if (message && message.ext.event == '15' && message.to == that.liveDetail.chatroomid) { // 观看人数
            that.onlineAudience = message.ext.clientonlinecount
          } else if (message && message.ext.event == '16' && message.to == that.liveDetail.chatroomid) { // 摄像头位置
            console.log('摄像头', message)
            that.$emit('Cameraposition', message.ext.location)
          }
        }, // 收到命令消息
        onCustomMessage (message) {
          console.log('onCmdMessage: ', message)
        }, // 收到自定义消息
        onAudioMessage (message) {
          console.log('onAudioMessage: ', message)
        }, // 收到音频消息
        onLocationMessage (message) {
          console.log('onLocMessage: ', message)
        }, // 收到位置消息
        onFileMessage (message) {
          console.log('onFileMessage: ', message)
        }, // 收到文件消息
        recallMessage (message) {
          console.log('recallMessage', message)
        }, // 消息撤回
        onVideoMessage (message) {
          console.log('onVideoMessage: ', message)
        }, // 收到视频消息
        onPresence (message) {
          const myDate = new Date().toLocaleString()
          console.log('onPresence: ', myDate + JSON.stringify(message))
        }, // 处理“广播”或“发布-订阅”消息，如联系人订阅请求、处理群组、聊天室被踢解散等消息
        onRoster (message) {
          for (let i = 0, l = message.length; i < l; i++) {
            const ros = message[i]
            if (ros.subscription === 'both' || ros.subscription === 'to') {
              console.log(ros.name)
            }
          }
        }, // 处理好友申请
        onInviteMessage (message) {
          console.log('Invite')
        }, // 处理群组邀请
        onOnline () {
          console.log('onOnline')
        }, // 本机网络连接成功
        onOffline () {
          console.log('offline')
        }, // 本机网络掉线
        onError (message) {
          console.log('onError: ', message)
        }, // 失败回调
        onBlacklistUpdate (list) {
          // 黑名单变动
          // 查询黑名单，将好友拉黑，将好友从黑名单移除都会回调这个函数，list则是黑名单现有的所有好友信息
          console.log(list)
        },
        onReceivedMessage (message) {
          message.name = 'chatroom'
          // const { id, mid, name } = message
          // console.log('id, mid, name: ', id, mid, name)
          // console.log('that.msgList[name]: ', that.msgList[name])
          // Object.keys(that.msgList[name]).forEach((user) => {
          //   if (that.msgList[name][user].length) {
          //     that.msgList[name][user].forEach((msg) => {
          //       if (msg.mid == id) {
          //         msg.mid = mid
          //       }
          //     })
          //   }
          // })
        }, // 收到消息送达服务器回执
        onDeliveredMessage (message) {
          console.log('onDeliveredMessage：', message)
        }, // 收到消息送达客户端回执
        onReadMessage (message) {
          console.log('onReadMessage: ', message)
        }, // 收到消息已读回执
        onCreateGroup (message) {
          console.log('onCreateGroup: ', message)
        }, // 创建群组成功回执（需调用createGroupNew）
        onMutedMessage (message) {
          const arr = that.$store.state.msgList
          const param = {
            bySelf: true,
            chatId: that.liveDetail.chatroomid,
            chatType: 'chatroom',
            mid: message.mid,
            msg: that.msg_text,
            nick: that.$store.state.user.nick,
            status: 'sending',
            time: new Date().getTime(),
            type: ''
          }

          if (!arr.chatroom[that.liveDetail.chatroomid]) {
            arr.chatroom[that.liveDetail.chatroomid] = []
          }
          arr.chatroom[that.liveDetail.chatroomid].push(param)
          that.$store.commit('set_msg', { arr, chatId: that.liveDetail.chatroomid })
          that.Forbidden = true
        } // 如果用户在A群组被禁言，在A群发消息会走这个回调并且消息不会传递给群其它成员
      })
    },
    // 环信IM进入聊天室
    getIMlist () {
      const that = this
      WebIM.conn.joinChatRoom({
        roomId: that.liveDetail.chatroomid, // 聊天室id
        success (res) {
          that.liveJoin() // IM加入聊天室
        }
      })
    },
    // 接口IM加入聊天室
    async liveJoin () {
      const res = await this.$api.liveroom.liveJoin({
        userId: this.$store.state.user.userId,
        liveRoomId: this.liveDetail.roomid,
        chatRoomsId: this.liveDetail.chatroomid,
        optUser: this.$store.state.user.userId || this.$Cookie.get('wiki-bfp') // 操作用户id
      })
      if (res) console.log('%c [opened] 聊天室加入成功', 'color: green')
    }
  }
}
